import { render, staticRenderFns } from "./issuefromsilo.vue?vue&type=template&id=03a5191a&scoped=true&"
import script from "./issuefromsilo.vue?vue&type=script&lang=js&"
export * from "./issuefromsilo.vue?vue&type=script&lang=js&"
import style0 from "./issuefromsilo.vue?vue&type=style&index=0&id=03a5191a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5191a",
  null
  
)

export default component.exports